let state = {
  io: {},
  drawer: true,
  gradient: 'rgba(0, 0, 0, .5), rgba(0, 0, 0, .7)',
  menus: [
    {
      title: 'ANALYTICS',
      items: [
        {
          title: 'Dashboard',
          icon: 'mdi-view-dashboard-outline',
          to: '/dashboard',
        },
      ],
    },
    {
      title: 'CONTENT',
      items: [
        {
          title: 'Order Sheet',
          icon: 'mdi-note-edit-outline',
          to: '/inquiry',
        },
        {
          title: 'Order List',
          icon: 'mdi-note-edit-outline',
          to: '/order',
        },
        {
          title: 'Samples',
          icon: 'mdi-laptop',
          to: '/analysis',
        },
        {
          title: 'Result',
          icon: 'mdi-chart-scatter-plot',
          to: '/result',
        },
        {
          title: 'Report',
          icon: 'mdi-chart-donut',
          to: '/datasets',
        },
        {
          title: 'MEASLES',
          icon: 'mdi-virus',
          to: '/virus',
        },
      ],
    },
    {
      title: 'USER',
      items: [
        {
          title: 'Profile',
          icon: 'mdi-account-box-outline',
          to: '/mypage',
        },
        {
          title: '1:1 Inquiry',
          icon: 'mdi-email-outline',
          to: '/contact',
        },
        {
          title: 'System Settings',
          icon: 'mdi-cog',
          to: '/admin',
        },
        {
          title: 'Logout',
          icon: 'mdi-logout-variant',
        },
      ],
    },
  ],
  reportMenus: [
    {
      title: 'ANALYTICS',
      items: [
        {
          title: 'Dashboard',
          icon: 'mdi-view-dashboard-outline',
          to: '/dashboard',
        },
      ],
    },
    {
      title: 'GENEREATE REPORT',
      items: [
        {
          title: 'WGS Report',
          icon: 'mdi-chart-donut',
          to: '/datasets',
        },
        {
          title: 'WGMX Report',
          icon: 'mdi-chart-donut',
          to: '/datasets',
        },
        {
          title: 'WMTX Report',
          icon: 'mdi-chart-donut',
          to: '/datasets',
        },
        {
          title: 'GUTMORNING',
          icon: 'mdi-chart-donut',
          to: '/datasets',
        },
        {
          title: 'QC Report',
          icon: 'mdi-chart-donut',
          to: '/datasets',
        },
      ],
    },
    {
      title: 'USER',
      items: [
        {
          title: 'Profile',
          icon: 'mdi-account-box-outline',
          to: '/mypage',
        },
        {
          title: '1:1 Inquiry',
          icon: 'mdi-email-outline',
          to: '/contact',
        },
        {
          title: 'System Settings',
          icon: 'mdi-cog',
          to: '/admin',
        },
        {
          title: 'Logout',
          icon: 'mdi-logout-variant',
        },
      ],
    },
  ],
};

const getters = {
  getDrawer: state => state.drawer,
};

const mutations = {
  setDrawer(state, data) {
    state.drawer = data;
  },
};

const actions = {
  toggleDrawer({ commit }, value) {
    commit('setDrawer', value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
